import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

import { useDisclosure, UseDisclosureReturn } from '@chakra-ui/react';

import { GroupModal } from '../components/GroupModal';

interface GroupModalProviderProps {
  children: ReactNode;
}

interface IGroupModalData extends UseDisclosureReturn {
  selectedGroupId: (value: string) => void;
}

const GroupModalContext = createContext({} as IGroupModalData);

export function GroupModalProvider({ children }: GroupModalProviderProps) {
  const disclosure = useDisclosure();
  const [groupId, setGroupId] = useState<string>('');

  const selectedGroupId = useCallback((value: string) => {
    setGroupId(value);
  }, []);

  return (
    <GroupModalContext.Provider value={{ ...disclosure, selectedGroupId }}>
      {children}
      <GroupModal groupId={groupId} />
    </GroupModalContext.Provider>
  );
}

export const useGroupModal = () => useContext(GroupModalContext);
